// Named on the animate-opts-in side of the boolean so call sites read as
// progressive enhancement: `if (allowsMotion()) { … animate … }`. Returns
// true only when the viewer's browser actively reports no preference —
// an explicit "reduce", an unknown value, or a missing matchMedia all
// fall through to false, so a viewer with reduced-motion needs (or one
// we can't ask) never gets animation by default.
const NO_PREFERENCE_QUERY = "(prefers-reduced-motion: no-preference)"

export function allowsMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false
  return window.matchMedia(NO_PREFERENCE_QUERY).matches
}
